//
//
//
//
//
//
//
//

import PageCreate from "@/0/components/0.comPage/01.comPageCreate2";
export default {
  components: {
    "page-create": PageCreate,
  },
  data() {
    return {
      dataConfig: {
        Form:{
          Url : "/mCmApi/PassageUserTask/GetCreateForm",
        }
      }
    };
  },
  
  methods:{
    

  }
};
